<div class="custom-modal">

  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content [class.no-scroll]="data.noScroll">
    <ng-container *ngTemplateOutlet="data.template; context: data.context">
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (data.actions && data.actions.length > 0) {
      @for (action of data.actions; track action.label) {
        <button mat-raised-button [color]="action.color || 'accent'" (click)="action.callback()">
          @if (action.icon) {
            <mat-icon>{{ action.icon }}</mat-icon>
          }
          {{ action.label }}
        </button>
      }
    }
    <button mat-raised-button color="primary" (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div>
